import { Radio } from '@material-ui/core';
import { defaultProps } from 'recompose';

import ControlTile from '@/components/ControlTile';

export default defaultProps({ Control: Radio })(ControlTile);
export { default as RadioBoxGroup } from './RadioBoxGroup';
